<template>
  <Layout>
    <SubHeader :title="$t('domain_lecture.title')" slot="sub-header">
      <div slot="sub-header-tab">
        <SubHeaderTab :items="lecturesType"
          :isStaticTab="true"
          :selectedId="selectedLectureType"
          @selectedTab="selectedTab" />
      </div>
    </SubHeader>
    <div slot="body">
      <template>
        <div class="domain-lectures-cover">
          <div class="cover-container">
            <div class="cover-icon">
              <img src="/static/images/img-main-sam.png" alt="sam">
            </div>
            <div class="cover-body">
              <span v-if="busy">{{ $t('common.sam_loading') }}</span>
              <span v-else>
                <span class="subejct" :style="{ 'background': domainSubjectColor }">{{ domainSubjectName }}</span>
                <span class="domain">{{ domainName }}</span><br>
                <span class="text"> {{ catDescription }}</span>
              </span>
            </div>
          </div>
        </div>

        <LoadingBounce v-if="busy" />
        <div v-else class="domain-lectures row">

          <template v-if="selectedLectureType === videoLectureType">
            <EmptyContent v-if="domainLectures.length === 0"
              :emptyContentText="emptyVideoLectureText" />
            <template v-else>
              <div class="col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-6"
                v-for="item in domainLectures" :key="item.id">
                <VideoCard :videoLecture="item"
                  :eventLabel="'more_lectures.video_lecture'" />
              </div>
              <InfiniteLoading v-if="domainLectures.length >= 10" @infinite="infiniteHandler" class="w-100">
                <div slot="spinner">
                  <LoadingBounce></LoadingBounce>
                </div>
                <span slot="no-results"></span>
                <span slot="no-more"></span>
              </InfiniteLoading>
            </template>
          </template>

          <template v-if="selectedLectureType === cardLectureType">
            <EmptyContent v-if="domainLectures.length === 0"
              :emptyContentText="emptyCardLectureText" />
            <template v-else>
              <div class="col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-6"
                v-for="item in domainLectures" :key="item.id">
                <ImageCard :cardLecture="item"
                :eventLabel="'more_lectures.card_lecture'" />
              </div>
              <InfiniteLoading v-if="domainLectures.length >= 10" @infinite="infiniteHandler" class="w-100">
                <div slot="spinner">
                  <LoadingBounce></LoadingBounce>
                </div>
                <span slot="no-results"></span>
                <span slot="no-more"></span>
              </InfiniteLoading>
            </template>
          </template>

        </div>
      </template>
    </div>
  </Layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';
  import { isEmpty, find, has } from 'lodash';

  export default {
    name: 'domain-lecture-view',

    data() {
      return {
        page: 1,
        limit: 10,
        busy: false,
        selectedLectureType: 1,
        videoLectureType: 1,
        cardLectureType: 2,
      };
    },

    components: {
      InfiniteLoading,
    },

    computed: {
      ...mapGetters({
        routeQuery: 'getRouteQuery',
        lecturesType: 'getLecturesType',
        filterDomainLectures: 'getFilterDomainLectures',
        filterDomainLecturesPosition: 'getFilterDomainLecturesPosition',
        domain: 'getDomain',
        subjectMap: 'getSubjectMap',
        learningElement: 'getLearningElements',
        isParentUser: 'isParentUser',
        currentUser: 'currentUser',
      }),

      domainLectures() {
        return this.filterDomainLectures[this.selectedLectureType] || [];
      },

      domainLecturesPosition() {
        return this.filterDomainLecturesPosition[this.selectedLectureType] || this.videoLectureType;
      },

      subjectId() {
        if (this.isDomainLecture) {
          return this.domain.subject_id;
        }

        return this.learningElement.subject_id;
      },

      filterSubject() {
        return find(this.subjectMap, { id: this.subjectId });
      },

      domainName() {
        if (this.isDomainLecture) {
          return this.domain.name;
        }

        return this.learningElement.name;
      },

      domainSubjectName() {
        return this.filterSubject.name;
      },

      domainId() {
        return this.routeQuery.domain_id;
      },

      learningElementId() {
        return this.routeQuery.learning_element_id;
      },

      isDomainLecture() {
        if (has(this.routeQuery, 'domain_id')) {
          return true;
        }

        return false;
      },

      domainSubjectColor() {
        return this.filterSubject.color_code;
      },

      catDescription() {
        if (this.isDomainLecture) {
          return this.$t('domain_lecture.domain_lecture_comment');
        }

        const currentUserName = this.isParentUser ? this.$t('common.child') : `${this.currentUser.name} ${this.$t('common.student')}`;
        return this.$t('domain_lecture.element_lecture_comment', { use: currentUserName });
      },

      emptyVideoLectureText() {
        return this.$t('domain_lecture.empty_video_lecture');
      },

      emptyCardLectureText() {
        return this.$t('domain_lecture.empty_card_lecture');
      },
    },

    methods: {
      ...mapActions([
        'fetchDomain',
        'fetchSubjects',
        'fetchDomainVideoLectures',
        'fetchDomainCardLectures',
        'resetDomainLectures',
        'resetDomainLecturesPosition',
        'fetchLectureLearningElement',
      ]),

      selectedTab(item) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: item.id === 1 ? 'more_lectures.type_video' : 'more_lectures.type_card',
          eventAction: 'click',
        });

        this.selectedLectureType = item.id;
      },

      infiniteHandler($state) {
        const filters = {};
        filters.page = this.domainLecturesPosition;
        filters.per_page = this.limit;
        if (this.isDomainLecture) {
          filters.domain_id = this.domainId;
        }

        if (!this.isDomainLecture) {
          filters.learning_element_id = this.learningElementId;
        }
        Promise.resolve()
          .then(() => {
            if (this.selectedLectureType === this.videoLectureType) {
              return this.fetchDomainVideoLectures(filters);
            }
            return this.fetchDomainCardLectures(filters);
          })
          .then((data) => {
            if (data.length > 0) {
              return $state.loaded();
            }
            return $state.complete();
          });
      },
    },

    beforeMount() {
      this.resetDomainLectures();
      this.resetDomainLecturesPosition();
      this.busy = true;
      Promise.resolve()
        .then(() => {
          if (this.isDomainLecture) {
            return this.fetchDomain(this.domainId);
          }

          return this.fetchLectureLearningElement(this.learningElementId);
        })
        .then(() => {
          if (isEmpty(this.subjectMap)) {
            return this.fetchSubjects();
          }
          return true;
        })
        .then(() => {
          const filters = {};
          filters.page = this.domainLecturesPosition;
          filters.per_page = this.limit;
          if (this.isDomainLecture) {
            filters.domain_id = this.domainId;
          }

          if (!this.isDomainLecture) {
            filters.learning_element_id = this.learningElementId;
          }
          return this.fetchDomainVideoLectures(filters);
        })
        .then(() => {
          this.busy = false;
        });
    },

    watch: {
      selectedLectureType(selected) {
        if (isEmpty(this.domainLectures) && selected === this.cardLectureType) {
          const filters = {};
          filters.page = this.domainLecturesPosition;
          filters.per_page = this.limit;
          if (this.isDomainLecture) {
            filters.domain_id = this.domainId;
          }

          if (!this.isDomainLecture) {
            filters.learning_element_id = this.learningElementId;
          }
          this.busy = true;
          this.fetchDomainCardLectures(filters)
            .then(() => {
              this.busy = false;
            });
        }
      },
    },

  };
</script>

<style lang="scss" scoped>

  .domain-lectures-cover {
    background: url('/static/images/img-sam-assignment-2.png') center center;
    height: 122px;
    background-repeat: no-repeat;
    background-size: cover;

    .cover-container {
      position: relative;
      max-width: 946px;
      margin: auto;
      height: 122px;

      .cover-icon {
        position: absolute;
        bottom: 0;
        display: inline-block;
        padding: 0px 14px 0px 14px;

        img {
          width: 84px;
          height: 84px;
        }
      }

      

      .cover-body {
        position: absolute;
        bottom: 14px;
        left: 100px;
        display: inline-block;
        vertical-align: top;
        padding: 12px;

        span {
          font-size: 14px;
          font-weight: 500;
          padding: 2px;
          color: #000000;
          overflow: hidden; 
          text-overflow: ellipsis; 
          white-space: nowrap;

          @media (max-width: 375px) {
            font-size: 12px;
          }
        }

        .subejct {
          color: #ffffff;
          padding: 2px 4px 2px 4px;
        }

        .domain {
          color: #000000;
          font-size: 16px;
          font-weight: bold;
          margin-left: 4px;
        }

        .text {
          line-height: 2;
        }
      }
    }
  }

  .domain-lectures {
    max-width: 946px;
    margin: auto;

    .empty-domain-lectures {
      width: 248px;
      margin: 0 auto;

      img {
        width: 100px;
        height: 100px;
        margin-top: 24%;
        margin-right: auto;
        margin-left: auto;
        display: block;
      }

      .title {
        margin: 14px;
        color: #979797;
        text-align: center;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// DomainLectureView.vue?3f1a1558